<template>
  <main class="page">
    <section class="section page__header">
      <div class="page__row">
        <div class="page__item">
          <h1 class="title">Типы договора</h1>
        </div>
      </div>
    </section>

    <section class="section page__content">
      <div class="page__row page__row_between mb-40">
        <div class="page__row">
          <div class="page__item user-list__search page__search">
            <SearchForm :value="searchValue"
                        @form-submit="setSearchValue"
            />
          </div>
        </div>
        <div class="page__item">
          <div class="page__row">
            <transition name="fade" v-if="roleAccessRemove">
              <div class="page__item" v-if="isActiveDelete">
                <AppButtonSmRemove title="Удалить" @click.stop.native="showRemoveConfirmationGroup" />
              </div>
            </transition>
            <div class="page__item" v-if="roleAccessCreate">
              <AppButtonSmAdd title="Создать"
                              @click.native="showModal(null)"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="page__row mb-20" v-if="types.length !== 0">
        <AppTable :data="types"
                  :headers="tableHeaders"
                  :has-checkbox="roleAccessRemove"
                  :isMenuControlsActive="false"
                  :all-items-active="tableHeaders.allActive"
                  @toggle-active-item="toggleActiveItem"
                  @toggle-active-all="toggleActiveAll"
                  @edit-this-item="showModal"
                  @show-this-item="showModal"
                  @save-item-info="saveContractTypeItem"
                  @remove-this-item="showRemoveConfirmation"
        />
      </div>
      <div class="page__row mb-20"  v-else>
        <div class="no-records">
          <AppNoRecordsPlaceholder text="Записи не найдены"/>
        </div>
      </div>
    </section>

    <section class="section page__footer user-list__footer">
      <div class="page__row" v-if="pagination.lastPage > 1">
        <VPagination
          :pageList="pagination.pageList"
          :currentPage="pagination.currentPage"
          @get-page="getPage"
        />
      </div>
    </section>

    <transition name="fade">
      <AppConfirmation v-if="removeConfirmation.active && roleAccessRemove"
                       :text="removeConfirmation.group ? 'Вы действительно хотите удалить эти типы?' : 'Вы действительно хотите удалить этот тип?'"
                       @confirm="removeConfirmation.group ? deleteContractsTypeChecked() : removeType()"
                       @reject="closeRemoveConfirmation"
      />
      <ContractTypeModal v-if="modal.active && roleAccessEdit"
                         :state="modal"
                         @set-item-name="setContractTypeName"
                         @save-item-info="saveContractTypeItem"
                         @close-modal="closeModal"
                         @clear-validation="clearModalValidation"
      />
      <AppModal v-if="deleteResponseModal.isActive && !deleteResponseModalWithTreaties.isActive && roleAccessRemove"
                :title="deleteResponseModal.title"
                :text="deleteResponseModal.text"
                confirmButtonTitle="Ок"
                :confirmButtonType="deleteResponseModal.type"
                @confirm="closeDeleteModal"
      />
      <AppModal v-if="deleteResponseModalWithTreaties.isActive && roleAccessRemove"
                :title="deleteResponseModalWithTreaties.title"
                :text="deleteResponseModalWithTreaties.text"
                confirmButtonTitle="Ок"
                :confirmButtonType="deleteResponseModalWithTreaties.type"
                @confirm="closeDeleteModalWithTreaties"
      />
    </transition>
    <ThePagePreloader v-if="isLoading"/>
  </main>
</template>

<script>

import SearchForm from '@/components/page/input/SearchForm'
import AppButtonSmAdd from '@/components/page/button/AppButtonSmAdd'
import AppTable from '@/components/page/table/AppTable'
import AppNoRecordsPlaceholder from '@/components/page/text/AppNoRecordsPlaceholder'
import AppConfirmation from '@/components/page/modal/AppConfirmation'
import ThePagePreloader from '@/components/page/ThePagePreloader'
import ContractTypeModal from '@/components/contract/ContractTypeModal'
import AppModal from '@/components/page/modal/AppModal'
import AppButtonSmRemove from '@/components/page/button/AppButtonSmRemove'
import VPagination from '@/components/page/VPagination'
import { mapGetters } from 'vuex'

export default {
  name: 'ContractType',
  components: {
    ContractTypeModal,
    ThePagePreloader,
    AppConfirmation,
    AppNoRecordsPlaceholder,
    AppTable,
    AppButtonSmAdd,
    SearchForm,
    AppModal,
    AppButtonSmRemove,
    VPagination
  },
  data () {
    return {
      removeConfirmation: {
        active: false,
        id: null,
        group: false
      }
    }
  },
  computed: {
    ...mapGetters('contractTypeListPage', [
      'getContractTypeListActiveDelete',
      'getContractTypeListIsLoading',
      'getContractTypeListModal',
      'getContractTypeListPagination',
      'getContractTypeListResponseModal',
      'getContractTypeListResponseModalWithTreaties',
      'getContractTypeListSearchValue',
      'getContractTypeTableHeaders',
      'getContractTypesList'
    ]),
    modal () {
      return this.getContractTypeListModal
    },
    currentUser () {
      return this.$store.getters.currentUser
    },
    types () {
      return this.getContractTypesList.map(type => {
        return ({
          id: type.id,
          isActive: type.isActive,
          values: [
            type.name
          ]
        })
      })
    },
    tableHeaders () {
      return this.getContractTypeTableHeaders
    },
    searchValue () {
      return this.getContractTypeListSearchValue
    },
    pagination () {
      return this.getContractTypeListPagination
    },
    isLoading () {
      return this.getContractTypeListIsLoading
    },
    deleteResponseModal () {
      return this.getContractTypeListResponseModal
    },
    deleteResponseModalWithTreaties () {
      return this.getContractTypeListResponseModalWithTreaties
    },
    isActiveDelete () {
      return this.getContractTypeListActiveDelete
    },
    roleAccessCreate () {
      return this.$store.getters.getRoleRightContracts.actions.add
    },
    roleAccessRemove () {
      return this.$store.getters.getRoleRightContracts.actions.remove
    },
    roleAccessEdit () {
      return this.$store.getters.getRoleRightContracts.actions.update
    }
  },
  methods: {
    showModal (itemId) {
      this.$store.dispatch('contractTypeListPage/showContractTypeModal', itemId)
    },
    closeModal () {
      this.$store.dispatch('contractTypeListPage/closeContractTypeModal')
    },
    toggleItemControls (itemId) {
      this.$store.dispatch('contractTypeListPage/toggleContractTypeControls', itemId)
    },
    toggleActiveItem (itemId) {
      this.$store.dispatch('contractTypeListPage/toggleContractTypeListItemActive', itemId)
    },
    toggleActiveAll () {
      this.$store.dispatch('contractTypeListPage/toggleContractTypeListItemActiveAll')
    },
    setContractTypeName (value) {
      this.$store.dispatch('contractTypeListPage/setContractTypeItemName', value)
    },
    saveContractTypeName (value) {
      this.$store.dispatch('contractTypeListPage/saveContractTypeItemName', value)
    },
    saveContractTypeItem (itemId) {
      this.$store.dispatch('contractTypeListPage/saveContractTypeItem', itemId)
    },
    showRemoveConfirmation (id) {
      this.removeConfirmation.active = true
      this.removeConfirmation.id = id
    },
    removeType () {
      const itemId = this.removeConfirmation.id
      this.$store.dispatch('contractTypeListPage/removeContractTypeItem', itemId)
      this.removeConfirmation.active = false
      this.removeConfirmation.id = null
    },
    clearModalValidation (value) {
      this.$store.dispatch('contractTypeListPage/clearContractTypeValidation', value)
    },
    closeRemoveConfirmation () {
      this.removeConfirmation.active = false
      this.removeConfirmation.id = null
    },
    showRemoveConfirmationGroup () {
      this.removeConfirmation.active = true
      this.removeConfirmation.id = null
      this.removeConfirmation.group = true
    },
    deleteContractsTypeChecked () {
      this.removeConfirmation.active = false
      this.$store.dispatch('contractTypeListPage/deleteContractTypeListCheckedItems')
      this.removeConfirmation.group = false
    },
    closeDeleteModal () {
      this.$store.dispatch('contractTypeListPage/closeContractTypeListDeleteModal')
    },
    closeDeleteModalWithTreaties () {
      this.$store.dispatch('contractTypeListPage/closeContractTypeListDeleteModalWithTreaties')
    },

    // search
    setSearchValue (value) {
      this.$store.dispatch('contractTypeListPage/setContractTypeListSearchValue', value)
    },

    // pagination
    getPage (pageNum) {
      this.$store.dispatch('contractTypeListPage/getContractTypeListPage', pageNum)
    }
  },
  mounted () {
    this.$store.dispatch('contractTypeListPage/getContractType')
  },
  destroyed () {
    this.$store.commit('contractTypeListPage/RESET_CONTRACT_TYPE_LIST_STORE')
  }
}
</script>

<style lang="scss" scoped>
.no-records {
  margin-top: 80px;
  align-items: center;
  width: 100%;
  display: flex;
}
</style>
